// Base mobule
export { default as Load } from './modules/Load';
export { default as Scroll } from './modules/Scroll';
export { default as ClassToggle } from './modules/ClassToggle';
// Accordion
export { default as Accordion } from './modules/Accordion';
// Accessibility Navigation
export { default as Accessibility } from './modules/Accessibility';
// Focus management
export { default as SetFocus } from './modules/SetFocus';
// Tabs
export { default as Tabs } from './modules/Tabs';
// Overlay
export { default as Overlay } from './modules/Overlay';
export { default as OverlayClose } from './modules/OverlayClose';
// Lightbox
export {default as GLightbox} from './modules/GLightbox';
// BrasFort Slider
export { default as Slider } from './modules/Slider';
// BrasFort Slider
// export { default as VideoPlayer } from './modules/VideoPlayer';
// File input Label
export {default as FileLabel} from './modules/FileLabel';
// Nav Controller
export { default as NavController } from './modules/NavController';
// Products Nav
export { default as ProductsNav } from './modules/ProductsNav';
// Legacy Tooltip from old blog
export { default as LegacyTooltip } from './modules/LegacyTooltip';
// Form Call Module
export {default as CallModule} from './modules/CallModule';
// Advantages
export {default as Advantages} from './modules/Advantages';
// Stats
export {default as Stat} from './modules/Stat';
// Modal
export { default as Modal } from './modules/Modal';
// Video VideoPlayer
export { default as VideoPlayer } from './modules/VideoPlayer';
// Tooltip
export { default as Tooltip } from './modules/Tooltip';
// Contact
export { default as Contact } from './modules/Contact';
// FoldVideo
export { default as FoldVideo } from './modules/FoldVideo';
// FlexibleForms
export { default as FlexibleForms } from './modules/FlexibleForms';
export { default as FlexibleFormsV2 } from './modules/FlexibleFormsV2';
export { default as Assureurs } from './modules/Assureurs';
export { default as Carriere } from './modules/Carriere';